import { useQuery } from '@tanstack/react-query';
import apiClient from '@/api/client';
import { useRefreshInterval } from './RefreshContext';

interface Backup {
  key: string;
  lastModified: string;
  size: number;
}

export type BackupsByDatabase = Record<string, Backup[]>;

export function useBackups() {
  const interval = useRefreshInterval();
  return useQuery({
    queryKey: ['cockpit', 'backups'],
    queryFn: async (): Promise<BackupsByDatabase> => {
      const res = await apiClient.get('/backups');
      return res.data;
    },
    refetchInterval: interval,
  });
}
